module.exports = __webpack_public_path__ + "static/media/violin.d3bf4413.mp3";